import { SERVER_URL } from '../utils/constants'

export const loginUserInLibrarian = async (userData) => {
  const {
    username,
    password,
    sessionId,
  } = userData
  const response = await fetch(
    `${SERVER_URL}/loginUserInLibrarian`, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      username,
      password,
      sessionId,
    }),
  }
  )
  if (response.status === 400) {
    const { errors } = await response.json()
    return { errors }
  }
  const data = await response.json()
  return data;
};

export const dLockLoginUserInLibrarian = async (data) => {

  const response = await fetch(
    `${SERVER_URL}/dLockLoginUserInLibrarian`, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  }
  )
  if (response.status === 400) {
    const { errors } = await response.json()
    return { errors }
  }
  const resp = await response.json()
  return resp;
}

export const dLockPairUserInLibrarian = async (data) => {

  const response = await fetch(
    `${SERVER_URL}/dLockPairUserInLibrarian`, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  }
  )

  if (response.status !== 200) {
    // response contains { error: "error message" }
    const error = await response.json();
    throw new Error(error.error);
  }
  return await response.json();
}

export const getdLockLibrarianPairStatus = async (username) => {

  const response = await fetch(
    `${SERVER_URL}/getdLockLibrarianPairStatus?username=${username}`, {
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
    },
  }
  )
  if (response.status === 400) {
    const { errors } = await response.json()
    return { errors }
  }
  const resp = await response.json()
  return resp;
}
